import React from 'react';
import DisplayFooterTime from '../../Utilities/DisplayFooterTime';

function Footer() {
  return (
    <footer>
      <span className="version">
        Version: 5.0 ©2023 GreenApples MedSystems LLC.
      </span>
      <span className="date-time">
        <DisplayFooterTime />
      </span>
    </footer>
  );
}

export default Footer;
